import { gql } from '@apollo/client';

export const fetchCreatedSubscriptionsForTransactionAccount = gql`
  query fetchCreatedSubscriptionsForTransactionAccount(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          transactionAccountId
          entitlementNumber
          createdDate
          productName
          productId
          cloudSiteId
          cloudSiteHostname
          logoId
          orgName
          orgProvisionedResourceType
          offering {
            id
            name
          }
        }
      }
    }
  }
`;
